<template>
    <div class="header-mobile-horizontal-menu">
        <div class="header-menu-inner">
            <template v-for="(link, index) in navigation">
                <span v-if="link.navigateViaJS" :key="`mobile-nav-link-${index}`" @click="navigateViaJS(link)" class="d-flex align-items-center">
                    <div v-if="link.title && link.title.toLowerCase().includes('livecam')" class="livecam-indicator"></div>
                    {{ link.title }}
                </span>
                <a v-else :href="link.path" :key="`mobile-nav-link-${index}`" :target="link.target || '_self'" class="d-flex align-items-center">
                    <div v-if="link.title && link.title.toLowerCase().includes('livecam')" class="livecam-indicator"></div>
                    {{ link.title }}
                </a>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        navigateViaJS(link) {
            window.open(link.path, link.target || '_self');
        }
    },
    computed: {
        ...mapState(['regionData']),
        navigation() {
            return _.get(this.regionData, 'mobileHorizontalLinks');
        },
    }
}
</script>
